import { Grid } from "@mui/material";
import UserDetailForm from "./UserDetailForm/UserDetailForm";
import UserDetailInfo from "./UserDetailInfo/UserDetailInfo";

const DeliveryInformationForm = ({
  isShow,
  getValues,
  control,
  watch,
  currentAsset,
}) => {
  return isShow ? (
    <>
      <Grid item xs={6}>
        <UserDetailForm
          getValues={getValues}
          control={control}
          currentAsset={currentAsset}
        />
      </Grid>
      <Grid item xs={6}>
        <UserDetailInfo getValues={getValues} watch={watch} />
      </Grid>
    </>
  ) : null;
};

export default DeliveryInformationForm;
